import { render, staticRenderFns } from "./Mfa.vue?vue&type=template&id=1331b06f"
import script from "./Mfa.vue?vue&type=script&lang=ts"
export * from "./Mfa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports